import { SimpleGrid } from "@mantine/core";
import RoomsCard from "./RoomsCard";
import AddRoomCard from "./AddRoomCard";

export default function RoomsGrid({ rooms, openRoom, openCreate, deleteRoom}) {

  return (

    <SimpleGrid
      cols={3}
      spacing="xl"
      breakpoints={[
        { maxWidth: "lg", cols: 2 },
        { maxWidth: "sm", cols: 1 }
      ]}
    >

      {rooms?.map((room) => (

        room && (
            <RoomsCard
            key={room._id}
            room={room}
            openRoom={openRoom}
            deleteRoom={deleteRoom}
            />
        )

        ))}
      <AddRoomCard openCreate={openCreate} />

    </SimpleGrid>

  );
}